import { getRolesForPath } from "../constants/routeConfig";

/** Accept only CRM routes the signed-in role can actually open. */
export function getAuthReturnPath(value, roles = []) {
  const path =
    typeof value === "string"
      ? value
      : value &&
        `${value.pathname || ""}${value.search || ""}${value.hash || ""}`;
  if (!path?.startsWith("/") || path.startsWith("//") || path.includes("\\"))
    return null;
  try {
    const url = new URL(path, "https://aviafy.invalid");
    if (
      url.origin !== "https://aviafy.invalid" ||
      !getRolesForPath(url.pathname).some((role) => roles.includes(role))
    )
      return null;
    return url.pathname + url.search + url.hash;
  } catch {
    return null;
  }
}
